import { Pill } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { topConfigContextAtom } from '../../../recoil/atoms/topConfigContextAtom';

const IconBoxGiftCard = ({
    textOnDesktop,
    textOnMobile
}: {
    textOnDesktop: string;
    textOnMobile: string;
}): React.JSX.Element => {
    const topConfigContext = useRecoilValue(topConfigContextAtom);

    return (
        <>
            <div
                style={{ borderRadius: '4px 4px 0 0', overflow: 'hidden' }}
                className="visible-md visible-lg u-bg-primary-1-base u-color-white"
            >
                <div className="u-flex-box u-flex-box--row u-flex-box--space-between u-flex-box--no-gap">
                    <p
                        style={{ padding: '9px 0 0 13px', fontWeight: '350' }}
                        className="small u-spacing-stack-none"
                    >
                        {textOnDesktop}
                    </p>
                    <img
                        alt="GiftCertificate"
                        src={`${topConfigContext?.resourceUrl ?? ''}/images/gogift-product-selector.svg`}
                    />
                </div>
            </div>
            <Pill
                content={textOnMobile}
                theme="primary"
                className="visible-xs visible-sm"
                id={'giftcard-pill'}
            />
        </>
    );
};

export { IconBoxGiftCard };
